import { renderReferralApplication, renderReferrerApplication } from '../renderApplication';

import { createContext } from './createContext';
import { createReferralApplicationState, createReferrerApplicationState } from '../applicationState';

export function runApp(): void {
  const context = createContext();
  const { custom } = context;

  if (custom.pageType === 'referrer') {
    const store = createReferrerApplicationState(context);

    renderReferrerApplication({ context, store });

    return;
  }

  if (custom.pageType === 'referral') {
    const store = createReferralApplicationState(context);

    renderReferralApplication({ context, store });

    return;
  }
}
